/* eslint-disable no-unused-vars */
export enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}
export const gridSpacing = 3;
export const drawerWidth = 250;
export const appDrawerWidth = 320;
